import React from 'react';

const favoriteContext = React.createContext({ isFavorite: null });

export default favoriteContext;
